



















































import A01PointNotificationPanelThanks from "@/general/components/pages/parts/Top/A01PointNotificationPanelThanks.vue";
import A01PointNotificationPanelInvested from "@/general/components/pages/parts/Top/A01PointNotificationPanelInvested.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay
} from "swiper";
import { Prop, Vue, Component } from "vue-property-decorator";
import "swiper/swiper-bundle.css";
import { PointNoticeCard } from "@/general/store/models";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";

SwiperClass.use([Pagination, Mousewheel, Autoplay]);

@Component({
  components: {
    A01PointNotificationPanelThanks,
    A01PointNotificationPanelInvested,
    Swiper,
    SwiperSlide
  }
})
export default class TheA01PointNotificationCarousel extends Vue {
  @Prop({ type: Array, required: true }) pointNoticeCards!: PointNoticeCard[];

  thanksPointTypes = [50];
  grantPointTypes = [20, 40, 90, 100];

  swiperOption = {
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  };

  get useCarousel() {
    return this.pointNoticeCards.length > 1;
  }

  urls(pointNoticeCard: PointNoticeCard) {
    if (this.grantPointTypes.includes(pointNoticeCard.transactionType)) {
      return `${CONST_DATA.SITE_MAP.DETAILS_GRANT_POINTS}?id=${pointNoticeCard.id}`;
    }
    return `${CONST_DATA.SITE_MAP.DETAILS_GRANT_THANKS}?id=${pointNoticeCard.id}`;
  }

  giver(pointNoticeCard: PointNoticeCard) {
    const userInfo = auth.user;
    return {
      id: userInfo?.user_id,
      user_image: pointNoticeCard.fromUserAvatar,
      user_name: pointNoticeCard.fromUserName
    };
  }
}
